// Add 'js-go-back' class to any link/button to go back in history.
// Done like this, because stage wysiwyg editors strip javascript
// And this was wanted in hero component.
const goBack = {
  init: function() {
    document.querySelectorAll('.js-go-back').forEach(trigger => {
      trigger.addEventListener('click', event => {
        event.preventDefault();
        window.history.go(-1);
      });
    });
  },
};

export default goBack;
